import axios from 'axios';
import { auth } from './Firebase';
export const CLOUD_FUNCTION_URL = process.env.REACT_APP_API_URL;
console.log("CLOUD_FUNCTION_URL",CLOUD_FUNCTION_URL);

// Kill switch for the Authorization header on Cloud Function calls. The backend only logs auth
// coverage today (doesn't enforce it), so flipping this to false is always safe.
export const ATTACH_AUTH_HEADER = true;
const ID_TOKEN_TIMEOUT_MS = 3000;

// Resolves to the signed-in user's Firebase ID token, or null if there is no user, the token
// fetch fails, or it takes longer than ID_TOKEN_TIMEOUT_MS. Never throws, so a slow token refresh
// can never block or break a request (e.g. payment calls).
export const getIdTokenSafe = async () => {
	try {
		const tokenPromise = (async () => {
			// On a fresh page load currentUser is null until Firebase restores the session.
			if (!auth.currentUser && typeof auth.authStateReady === 'function') {
				await auth.authStateReady();
			}
			return auth.currentUser ? await auth.currentUser.getIdToken() : null;
		})().catch(() => null);
		const timeoutPromise = new Promise((resolve) =>
			setTimeout(() => resolve(null), ID_TOKEN_TIMEOUT_MS)
		);
		return (await Promise.race([tokenPromise, timeoutPromise])) || null;
	} catch (e) {
		return null;
	}
};

const isCloudFunctionUrl = (url) =>
	!!CLOUD_FUNCTION_URL &&
	typeof url === 'string' &&
	url.startsWith(CLOUD_FUNCTION_URL);

// Returns axios config with `Authorization: Bearer <token>` only for our Cloud Functions and only
// when a token exists; otherwise undefined (axios defaults, same as an unauthenticated call).
const getAxiosHeader = async (url) => {
	try {
		if (!ATTACH_AUTH_HEADER || !isCloudFunctionUrl(url)) return undefined;
		const token = await getIdTokenSafe();
		if (!token) return undefined;
		return {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
	} catch (e) {
		return undefined;
	}
};

export const postRequest = async (url, params) => {
	const header = await getAxiosHeader(url);
	try {
		const response = await axios.post(url, params, header);
		return response;
	} catch (e) {
		// console.log("getRequest err",e);
	}
};

// Like postRequest, but an HTTP error (4xx/5xx) resolves to its response instead of undefined, so the
// caller can read the body (e.g. 409 {error: 'mandate_exists'}). Network errors still resolve undefined.
export const postRequestWithResponse = async (url, params) => {
	const header = await getAxiosHeader(url);
	try {
		return await axios.post(url, params, header);
	} catch (e) {
		return e?.response;
	}
};

export const getRequest = async (url, params) => {
	const header = await getAxiosHeader(url);
	try {
		const response = await axios.post(url, params, header);
		return response;
	} catch (e) {
		// console.log("getRequest err",e);
	}
};
